import moment from "moment";
import axios from "axios";
import { ScanDocumentType, OCREndpoints } from "./Constants";

/**
 * Convert a base64 string to File object
 */
function blobToFile(base64Image: string): File {
  const fileName = "document_" + moment().format("YYYYMMDD_HHmmss") + ".png";

  // Convert base64 to raw binary data
  const byteString = atob(base64Image.split(",")[1]);
  const mimeString = base64Image.split(",")[0].split(":")[1].split(";")[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, {
    type: mimeString,
    lastModified: moment().unix(),
  });
}


 async function processImage(image: string, documentType: string = ScanDocumentType.ID): Promise<any> {
   const instance = axios.create({
    baseURL: process.env.REACT_APP_PROCESS_IMAGE_URL || "http://localhost:5050",
    headers: {
      // Remove content-type header here - let axios set it automatically for FormData
    },
  });

  const file = blobToFile(image);

  // Create FormData and append the file
  const formData = new FormData();
  formData.append('file', file); // 'file' is the field name - adjust if your API expects a different name

  // Get the endpoint based on document type
  const endpoint = OCREndpoints[documentType] || OCREndpoints[ScanDocumentType.ID];

  try {
    const response = await instance.post(
      `${endpoint}?backend=gemini&skip_quality_check=false`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          // authorization: `Bearer ${testOCRToken}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    }
    throw new Error(`Unexpected response status: ${response.status}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
 }

export { processImage, blobToFile };
